module.exports = __webpack_public_path__ + "static/fonts/HurmeGeometricSans2-SemiBold.a2e239f9.woff2";